export default function StatCard({ label, value, testId }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5" data-testid={testId}>
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">{label}</div>
      <div className="text-3xl font-bold text-slate-900">{value}</div>
    </div>
  );
}
